import { useMemo, useState } from 'react';

export const useNetworkState = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [lastOnline, setLastOnline] = useState(navigator.onLine ? Date.now() : 0);
  const [lastOffline, setLastOffline] = useState(!navigator.onLine ? Date.now() : 0);

  const isOffline = useMemo(() => !isOnline, [isOnline]);

  window.addEventListener('online', () => {
    if (!isOnline) {
      setIsOnline(true);
      setLastOnline(Date.now());
    }
  });

  window.addEventListener('offline', () => {
    if (isOnline) {
      setIsOnline(false);
      setLastOffline(Date.now());
    }
  });

  const wasOffline = (millisecondsAgo: number) => {
    // We have to do this rather than use one of the nicer states or memos above
    // because we unfortunately hit a timing issue where we get the wrong value as react
    // hasn't updated the children as required (think component batching).
    if (!navigator.onLine) {
      return true;
    }

    if (lastOffline === 0) {
      return false;
    }

    return Date.now() - lastOffline < millisecondsAgo;
  };

  return {
    isOnline,
    isOffline,
    lastOnline,
    lastOffline,
    wasOffline,
  };
};
